module.exports = __webpack_public_path__ + "img/pic-prize.4e06ba6a.png";